import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, Check, X, Mail, Briefcase } from "lucide-react";
import api from "../lib/api";
import { Spinner } from "../components/common";

export default function AdminOfficials() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/officials/requests?status=pending").then((r) => setItems(r.data.items)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const act = async (id, action) => {
    try { await api.post(`/officials/requests/${id}/${action}`); toast.success(action === "approve" ? "Approved" : "Rejected"); load(); }
    catch { toast.error("Action failed"); }
  };

  return (
    <div className="max-w-4xl mx-auto px-5 lg:px-8 py-10" data-testid="admin-officials">
      <h1 className="font-heading font-900 text-3xl sm:text-4xl tracking-tight flex items-center gap-2"><ShieldCheck className="w-7 h-7 text-sky-600" /> Official account requests</h1>
      <p className="text-muted-foreground mt-2">Approve verified representatives so they can post official responses on their airline/airport page.</p>

      <div className="mt-8">
        {!items ? <Spinner /> : items.length === 0 ? (
          <p className="text-muted-foreground">No pending requests.</p>
        ) : (
          <div className="space-y-3">
            {items.map((r) => (
              <div key={r.id} className="border border-zinc-300 bg-white p-4" data-testid={`official-req-${r.id}`}>
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="font-700">{r.entity_name} <span className="text-xs font-mono uppercase text-muted-foreground">({r.entity_type})</span></div>
                    <div className="text-sm text-muted-foreground flex flex-wrap gap-x-4 gap-y-1 mt-1">
                      <span className="inline-flex items-center gap-1"><Briefcase className="w-3.5 h-3.5" /> {r.org_name} · {r.role_title}</span>
                      <span className="inline-flex items-center gap-1"><Mail className="w-3.5 h-3.5" /> {r.work_email}</span>
                    </div>
                    <div className="text-sm mt-1">Requested by <strong>{r.user_name}</strong> ({r.user_email})</div>
                    {r.proof_note && <div className="text-sm text-zinc-600 mt-2 border-l-2 border-zinc-200 pl-3">{r.proof_note}</div>}
                  </div>
                  <div className="flex gap-2 shrink-0">
                    <button onClick={() => act(r.id, "approve")} data-testid={`official-approve-${r.id}`} className="inline-flex items-center gap-1 bg-emerald-600 text-white px-3 py-2 text-sm font-600 hover:bg-emerald-700"><Check className="w-4 h-4" /> Approve</button>
                    <button onClick={() => act(r.id, "reject")} data-testid={`official-reject-${r.id}`} className="inline-flex items-center gap-1 border border-zinc-300 px-3 py-2 text-sm font-600 hover:border-destructive hover:text-destructive"><X className="w-4 h-4" /> Reject</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
